module.exports = "/images/dashboard.svg?4c7e6bccd947dd1dcba7d47318d02547";